// @flow

import type {TreeItem} from '../typedef';

export const hasId = ({id, children}: TreeItem, idsList: Array<string>): boolean => {
    if (idsList.includes(id)) {
        return true;
    }

    if (!children) {
        return false;
    }

    return children.some(child => hasId(child, idsList));
};
